import { render } from "./FormsFilter.vue?vue&type=template&id=818aafd0&scoped=true&ts=true"
import script from "./FormsFilter.ts?vue&type=script&lang=ts&external"
export * from "./FormsFilter.ts?vue&type=script&lang=ts&external"

import "./FormsFilter.scss?vue&type=style&index=0&id=818aafd0&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-818aafd0"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QIcon,QPopupProxy,QDate,QBtn,QSelect,QOptionGroup,QDialog,QCard,QPage,QPageContainer,QCardActions});qInstall(script, 'directives', {ClosePopup});
